"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserServiceStub = void 0;
const mystake_common_sdk_1 = require("@boulevard1/mystake-common-sdk");
const faker = __importStar(require("faker"));
const fakeUserProfile = {
    _id: faker.random.uuid(),
    salutation: faker.name.prefix(),
    familyName: faker.name.lastName(),
    firstName: faker.name.lastName(),
    emails: [
        {
            email: faker.internet.email(),
            isPrimary: faker.random.boolean(),
            isVerified: faker.random.boolean(),
        },
    ],
    phones: [
        {
            iso2: faker.address.countryCode(),
            dialCode: faker.phone.phoneNumber(),
            phoneNumber: faker.phone.phoneNumber(),
            isPrimary: faker.random.boolean(),
            isVerified: faker.random.boolean(),
        },
    ],
    username: faker.random.uuid(),
    birthDetails: {
        dob: faker.date.past(20),
        birthPlace: faker.address.city(),
        birthCountry: faker.address.country(),
    },
    kycDetails: {
        isKYCDone: faker.random.boolean(),
        address: {
            // flatNumber: faker.address.secondaryAddress(),
            description: "987/12345 Street St, QLD, AU",
            flatNumber: "987",
            streetNumber: "12345",
            streetName: faker.address.streetName(),
            suburb: faker.address.city(),
            postcode: faker.address.zipCode(),
            // state: faker.address.state(),
            state: "QLD",
            // country: faker.address.country(),
            country: "AU",
        },
        verificationId: "",
        verificationToken: "",
    },
    companyIds: faker.random.boolean() ? [faker.random.uuid()] : [faker.random.uuid(), faker.random.uuid()],
    onboardingStatus: [
        mystake_common_sdk_1.CompanyListItemStatus.ReadyForReview,
        mystake_common_sdk_1.CompanyListItemStatus.KYCPending,
        mystake_common_sdk_1.CompanyListItemStatus.SetUpInProgress,
        mystake_common_sdk_1.CompanyListItemStatus.AddPaymentMethod,
    ][faker.random.number({ min: 0, max: 3 })],
    isInvestor: faker.random.boolean(),
    isExternalInvestor: faker.random.boolean(),
    roles: [mystake_common_sdk_1.Roles.ADMIN],
    rolesByCompany: [
        {
            companyId: faker.random.uuid(),
            roles: [mystake_common_sdk_1.Roles.ADMIN],
        },
    ],
    nomineeCompanies: [],
    lastLogin: new Date(2019, 2, 18),
};
class UserServiceStub {
    isNominee() {
        return __awaiter(this, void 0, void 0, function* () {
            return { isNominee: faker.random.boolean(), nomineeForCompanyIds: [] };
        });
    }
    updateKycDoneStatus() {
        return __awaiter(this, void 0, void 0, function* () {
            return faker.random.boolean();
        });
    }
    getUser() {
        return __awaiter(this, void 0, void 0, function* () {
            return fakeUserProfile;
        });
    }
    getUserById(userId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (userId) {
                return Promise.resolve(fakeUserProfile);
            }
            return Promise.resolve(fakeUserProfile);
        });
    }
    updateUserPrimaryPhone(phoneDetails) {
        return __awaiter(this, void 0, void 0, function* () {
            if (phoneDetails) {
                return faker.random.boolean();
            }
            return false;
        });
    }
    isEmailExists(email) {
        return __awaiter(this, void 0, void 0, function* () {
            if (email) {
                return faker.random.boolean();
            }
            return false;
        });
    }
    isAcnExists(acn) {
        return __awaiter(this, void 0, void 0, function* () {
            if (acn) {
                return faker.random.boolean();
            }
            return false;
        });
    }
    updateEmail(email) {
        return __awaiter(this, void 0, void 0, function* () {
            if (email) {
                return faker.internet.email();
            }
            return null;
        });
    }
    updateDobAddress(dobAddressData) {
        return __awaiter(this, void 0, void 0, function* () {
            if (dobAddressData) {
                return faker.random.boolean();
            }
            return false;
        });
    }
    removePreKycDetails() {
        return __awaiter(this, void 0, void 0, function* () {
            return faker.random.boolean();
        });
    }
    updateKycDetails(updateKycDetailsData) {
        if (updateKycDetailsData) {
            return Promise.resolve(faker.random.boolean());
        }
        // eslint-disable-next-line prefer-promise-reject-errors
        return Promise.reject(false);
    }
    updateAddressDetails(updateAddressDetailsData) {
        if (updateAddressDetailsData) {
            return Promise.resolve(faker.random.boolean());
        }
        // eslint-disable-next-line prefer-promise-reject-errors
        return Promise.reject(false);
    }
    requestPasswordReset(requestPasswordResetRequestBody) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestPasswordResetRequestBody) {
                return faker.random.boolean()
                    ? Promise.resolve({
                        status: true,
                        message: "Password Reset Email Sent",
                        payload: null,
                    })
                    : // eslint-disable-next-line prefer-promise-reject-errors
                        Promise.reject({
                            status: false,
                            message: "User doesn't exist or Failed to send password reset email",
                            payload: null,
                        });
            }
            // eslint-disable-next-line prefer-promise-reject-errors
            return Promise.reject({
                status: false,
                message: "Request body is required",
            });
        });
    }
    setNewPassword(authToken, setNewPasswordRequestBody) {
        return __awaiter(this, void 0, void 0, function* () {
            if (authToken && setNewPasswordRequestBody) {
                if (setNewPasswordRequestBody.password === setNewPasswordRequestBody.confirmPassword) {
                    return Promise.resolve({
                        status: true,
                        message: "Password updated!",
                        payload: null,
                    });
                }
                // eslint-disable-next-line prefer-promise-reject-errors
                return Promise.reject({
                    status: false,
                    message: "Passwords must match!",
                    payload: null,
                });
            }
            // eslint-disable-next-line prefer-promise-reject-errors
            return Promise.reject({
                status: false,
                message: "Failed to update password",
                payload: null,
            });
        });
    }
    verifyThenUpdateMobileNumber(verifyThenUpdateMobileNumberRequestBody) {
        return __awaiter(this, void 0, void 0, function* () {
            if (verifyThenUpdateMobileNumberRequestBody) {
                return faker.random.boolean()
                    ? Promise.resolve({
                        status: true,
                        message: "Successfully verified and updated mobile number",
                        payload: null,
                    })
                    : // eslint-disable-next-line prefer-promise-reject-errors
                        Promise.reject({
                            status: false,
                            message: "Invalid code",
                            payload: null,
                        });
            }
            // eslint-disable-next-line prefer-promise-reject-errors
            return Promise.reject({ status: false, message: "Invalid request" });
        });
    }
    linkNomineeExistingAccount(linkNomineeExistingAccountRequestBody) {
        return __awaiter(this, void 0, void 0, function* () {
            if (linkNomineeExistingAccountRequestBody) {
                Promise.resolve({
                    status: true,
                    message: "Account linked successfully to company XYZ Pty. Ltd.",
                    payload: null,
                });
            }
            // eslint-disable-next-line prefer-promise-reject-errors
            return Promise.reject({
                status: false,
                message: "Invalid request",
                payload: null,
            });
        });
    }
    updateLastLogin(username) {
        return __awaiter(this, void 0, void 0, function* () {
            if (username) {
                return faker.random.boolean();
            }
            return false;
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getUserCompanies() {
        return __awaiter(this, void 0, void 0, function* () {
            return {
                status: true,
                message: "Successfully got companies",
                payload: null,
            };
        });
    }
    grantShareholderRole(companyId, role) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId && role) {
                return {
                    status: true,
                    message: "Successfully granted Shareholder role access",
                    payload: fakeUserProfile.rolesByCompany[0],
                };
            }
            return {
                status: false,
                message: "Failed to grant Shareholder role access",
                payload: null,
            };
        });
    }
    getInvestorProfiles(companyId, filterByCompany, status, keyword, page, rowsPerPage, sortBy, sortOrder) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId && filterByCompany && status && page && rowsPerPage && sortBy && sortOrder && keyword) {
                const userInvestorData = {};
                return {
                    status: true,
                    message: "Succesfully fetched user investor profiles",
                    payload: userInvestorData,
                };
            }
            return {
                status: false,
                message: "Failed to fetch user investor profiles",
                payload: null,
            };
        });
    }
}
exports.UserServiceStub = UserServiceStub;
//# sourceMappingURL=UserServiceStub.js.map